export function capitalizeWords(string: string) {
  return string.replace(/\b./g, (letter) => letter.toUpperCase());
}
